import { FC } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import styles from './ActivityHeader.module.scss';

interface ActivityHeaderProps {
  onClose: () => void;
  title?: string;
}

const ActivityHeader: FC<ActivityHeaderProps> = ({ onClose, title = 'Stop Details' }) => {
  return (
    <Box className={styles.header}>
      <Typography
        variant="h5Bold"
        className={styles.title}
      >
        {title}
      </Typography>

      <IconButton
        onClick={onClose}
        className={styles.closeButton}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default ActivityHeader;
